/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FlowItemBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./FlowItemBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.FlowItemBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.FlowItemBean);
  }
}(this, function(ApiClient, FlowItemBean) {
  'use strict';

  /**
   * The FlowItemBean model module.
   * @module model/FlowItemBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>FlowItemBean</code>.
   * @alias module:model/FlowItemBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>FlowItemBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FlowItemBean} obj Optional instance to populate.
   * @return {module:model/FlowItemBean} The populated <code>FlowItemBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = FlowItemBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('fileUrls'))
        obj.fileUrls = ApiClient.convertToType(data['fileUrls'], ['String']);
      if (data.hasOwnProperty('flowId'))
        obj.flowId = ApiClient.convertToType(data['flowId'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('imageUrls'))
        obj.imageUrls = ApiClient.convertToType(data['imageUrls'], ['String']);
      if (data.hasOwnProperty('inputJson'))
        obj.inputJson = ApiClient.convertToType(data['inputJson'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('notes'))
        obj.notes = ApiClient.convertToType(data['notes'], 'String');
      if (data.hasOwnProperty('outputJson'))
        obj.outputJson = ApiClient.convertToType(data['outputJson'], 'String');
      if (data.hasOwnProperty('sequence'))
        obj.sequence = ApiClient.convertToType(data['sequence'], 'Number');
      if (data.hasOwnProperty('statusList'))
        obj.statusList = ApiClient.convertToType(data['statusList'], ['String']);
      if (data.hasOwnProperty('toolGroupId'))
        obj.toolGroupId = ApiClient.convertToType(data['toolGroupId'], 'String');
      if (data.hasOwnProperty('toolId'))
        obj.toolId = ApiClient.convertToType(data['toolId'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {Boolean} active
   */
  exports.prototype.active = undefined;

  /**
   * @member {module:model/FlowItemBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Array.<String>} fileUrls
   */
  exports.prototype.fileUrls = undefined;

  /**
   * @member {String} flowId
   */
  exports.prototype.flowId = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<String>} imageUrls
   */
  exports.prototype.imageUrls = undefined;

  /**
   * @member {String} inputJson
   */
  exports.prototype.inputJson = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} notes
   */
  exports.prototype.notes = undefined;

  /**
   * @member {String} outputJson
   */
  exports.prototype.outputJson = undefined;

  /**
   * @member {Number} sequence
   */
  exports.prototype.sequence = undefined;

  /**
   * @member {Array.<String>} statusList
   */
  exports.prototype.statusList = undefined;

  /**
   * @member {String} toolGroupId
   */
  exports.prototype.toolGroupId = undefined;

  /**
   * @member {String} toolId
   */
  exports.prototype.toolId = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/FlowItemBean.js